import React, { useState, useEffect, useContext, useMemo} from "react";
import { Link } from "react-router-dom";
import { LangContext } from "../../context/lang-context";
import useFetch from "../../hooks/fetchMSSQL-hook";
import { NavigationContext } from '../../context/navigation-context';
import moment from "moment";
import ReportButton from "../../components/Buttons/ReportButton";
import SearchFilter from "../../components/Filter/SearchFilter";

const WIS = () => {
  const { setHeaderData } = useContext(NavigationContext);
  const { TRL_Pack } = useContext(LangContext);
  const { fetchMssqlApi } = useFetch();
  const [WIS, setWIS] = useState(null);

  const defaultAdditionalFilter = {wi: "", user: "", date: "", machine: "", pa: "", kp: "", inm: "", do: "", ko: ""};
  const [additionalFilter, setAdditionalFilter] = useState(defaultAdditionalFilter);

  const reportList = [ 
    {reportId: 75, reportColor: "primary"}, 
    {reportId: 79, reportColor: "success"}, 
    {reportId: 101, reportColor: "dark"}
  ]

  const defaultFilter = {
    page: 1,
    sortBy: "none",
    dateTimeRangeFrom: moment().startOf("day").format("YYYY-MM-DDTHH:mm:ss"), 
    dateTimeRangeTo: moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss"), 
    zeroPA: "null",
    telemetry: "null",
    machineName: "",
    machineId: null,
    machineTags: { id: [], name: [] },
    userName: "",
    userId: null
  }
  
  const [filter, setFilter] = useState(defaultFilter);
  const [settingsFilter, setSettingsFilter] = useState();
  
  useEffect(() => {
    setHeaderData({ text: "Wizyty" });
  }, [setHeaderData]);


  const parseThreeState = (val) => {if (val === "false") return false; if (val === "true") return true; return null;};

   const getMachineIdsByTags = (machineTagIds) => {
    return new Promise((resolve, reject) => {
      fetchMssqlApi(
        "tags/getMachineIdsByTags",
        { method: "POST", hideNotification: true, data: { machineTagIds } },
        (response) => { resolve(JSON.stringify(response.map(Number).filter(Number.isFinite)) || [])},
        (err) => reject(err)
      );
    });
  };

  const getSortState = () => {
    const [field, dir] = String(filter.sortBy || "").split("|");
    return { field, dir: (dir || "").toUpperCase() };
  };

  const sortState = getSortState();

  const arrow = (field) => {
    if (sortState.field !== field) return "";
    return sortState.dir === "ASC" ? " ▲" : " ▼";
  };

  const handleHeaderSort = (field) => {
    const [curField, curDirRaw] = String(filter.sortBy || "none").split("|");
    const curDir = (curDirRaw || "").toUpperCase();
    let sortBy;
    if (curField !== field) {sortBy = `${field}|DESC`;
    } else if (curDir === "DESC") {sortBy = `${field}|ASC`;
    } else if (curDir === "ASC") {sortBy = "none";
    } else sortBy = `${field}|DESC`;
    const next = { ...filter, sortBy, page: 1 };
    setFilter(next);
    getWIS(next, settingsFilter.rowsPerPage, 1);
  };

  const addKP = (visitId) => {
    fetchMssqlApi( "kp-add", { method: "POST", hideNotification: true, data: {visitId: visitId}}, () => getWIS(filter));
  };

  const getWIS = async (f, pageSize, page) => {
    let rowsPerPage = settingsFilter?.rowsPerPage ?? 100;
    if (pageSize != null) rowsPerPage = pageSize;
    const pageNo = Math.max(1, Number(page ?? f?.page) || 1);
    let machineIds = "[]";
    if (f?.machineTags?.id?.length > 0) { machineIds = await getMachineIdsByTags(f.machineTags.id)} 
    if (f?.machineId) {const arr = JSON.parse(machineIds); arr.push(Number(f.machineId)); machineIds = JSON.stringify(arr);}
    fetchMssqlApi("visit-wis", {method: "POST", hideNotification: true,
        data: {
          isZeroTotal: parseThreeState(f.zeroPA),
          isTelemetry: parseThreeState(f.telemetry),
          fromCreateDateTime: f.dateTimeRangeFrom,
          toCreateDateTime: f.dateTimeRangeTo,
          machineTags: f.machineTags?.id?.length ? f.machineTags.id : null,
          machineId: machineIds,
          createUserId: f.userId,
          page: pageNo,
          rowsPerPage,
          sortBy: f?.sortBy
        },
      },
      (response) => {
        setWIS(response ?? []);
      }
    );
  };

  const filtered = useMemo(() => {
    return WIS?.filter(item =>
      (additionalFilter.wi === '' || `${item.WI || ''}`.toLowerCase().includes(additionalFilter.wi.toLowerCase())) &&
      (additionalFilter.user === '' || `${item.CreatedBy || ''}`.toLowerCase().includes(additionalFilter.user.toLowerCase())) &&
      (additionalFilter.date === '' || `${item.VisitCreated || ''}`.toLowerCase().includes(additionalFilter.date.toLowerCase())) &&
      (additionalFilter.machine === '' || `${item.MachineFullName || ''}`.toLowerCase().includes(additionalFilter.machine.toLowerCase())) &&
      (additionalFilter.pa === '' || `${item.PA || ''}`.toLowerCase().includes(additionalFilter.pa.toLowerCase())) &&
      (additionalFilter.kp === '' || `${item.KP || ''}`.toLowerCase().includes(additionalFilter.kp.toLowerCase())) &&
      (additionalFilter.inm === '' || `${item.INm || ''}`.toLowerCase().includes(additionalFilter.inm.toLowerCase())) &&
      (additionalFilter.do === '' || `${item.DO || ''}`.toLowerCase().includes(additionalFilter.do.toLowerCase())) &&
      (additionalFilter.ko === '' || `${item.KO || ''}`.toLowerCase().includes(additionalFilter.ko.toLowerCase()))
    ) ?? [];
  }, [WIS, additionalFilter]);

  return (
    <div className="container-fluid p-0">
      <SearchFilter 
        filterName="wis" 
        defaultFilter={defaultFilter} 
        reportList={reportList}
        onFilterChange={(f) => setFilter(f)} 
        onSettingsChange={(s) => setSettingsFilter(s)} 
        search={getWIS}
        totalCount={WIS?.length}
        defaultAdditionalFilter={defaultAdditionalFilter}
        additionalFilter={additionalFilter}
        onAdditionalFilterChange={(af) => setAdditionalFilter(af)}
        forNow
      />
      <div className="container-fluid">
        <div className="border overflow-auto custom-scroll" style={{ overflowY: "auto"}}>
          <table className="table table-striped">
            <colgroup>
              <col style={{ minWidth: "155px", width: "155px" }}/>
              <col style={{ minWidth: "150px"}}/>
              <col style={{ minWidth: "160px", width: "160px" }}/>
              <col style={{ minWidth: "250px"}}/>
              <col style={{ minWidth: "145px", width: "145px" }}/>
              <col style={{ minWidth: "170px", width: "170px" }}/>
              <col style={{ minWidth: "145px", width: "145px" }}/>
              <col style={{ minWidth: "145px", width: "145px" }}/>
              <col style={{ minWidth: "145px", width: "145px" }}/>
              <col style={{ minWidth: "50px", width: "50px", maxWidth: "50px" }}/>
            </colgroup>
            <thead>
              <tr className="text-center headers-color">
                <td>
                  <div className="d-flex flex-column align-items-center">
                    <span style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("WI")}>Wizyta{arrow("WI")}</span>
                    <input type="text" value={additionalFilter.wi || ""} onChange={({target:{value}}) => setAdditionalFilter(prev => ({...prev, wi: value}))} style={{backgroundColor: additionalFilter.wi ? "#d1d5db" : "#f8f9fa", border: additionalFilter.wi ? "2px solid #634b4b" : "1px solid #ccc", boxShadow: additionalFilter.wi ? "0 0 0 2px rgba(75,85,99,.15)" : "none", fontWeight: additionalFilter.wi ? "600" : "normal", color: additionalFilter.wi ? "#111827" : "inherit", width: "100%", minWidth: "90px", maxWidth: "150px", textAlign: "center", padding: "2px 4px", fontSize: "10px", height: "22px", borderRadius: "3px"}} />
                  </div>
                </td>
                <td>
                  <div className="d-flex flex-column align-items-center">
                    <span style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("User")}>Serwisant{arrow("User")}</span>
                    <input type="text" value={additionalFilter.user || ""} onChange={({target:{value}}) => setAdditionalFilter(prev => ({...prev, user: value}))} style={{backgroundColor: additionalFilter.user ? "#d1d5db" : "#f8f9fa", border: additionalFilter.user ? "2px solid #634b4b" : "1px solid #ccc", boxShadow: additionalFilter.user ? "0 0 0 2px rgba(75,85,99,.15)" : "none", fontWeight: additionalFilter.user ? "600" : "normal", color: additionalFilter.user ? "#111827" : "inherit", width: "100%", minWidth: "90px", maxWidth: "150px", textAlign: "center", padding: "2px 4px", fontSize: "10px", height: "22px", borderRadius: "3px"}} />
                  </div>
                </td>
                <td>
                  <div className="d-flex flex-column align-items-center">
                    <span  style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("CreateDateTime")}>Czas zapisu {arrow("CreateDateTime")}</span>
                    <input type="text" value={additionalFilter.date || ""} onChange={({target:{value}}) => setAdditionalFilter(prev => ({...prev, date: value}))} style={{backgroundColor: additionalFilter.date ? "#d1d5db" : "#f8f9fa", border: additionalFilter.date ? "2px solid #634b4b" : "1px solid #ccc", boxShadow: additionalFilter.date ? "0 0 0 2px rgba(75,85,99,.15)" : "none", fontWeight: additionalFilter.date ? "600" : "normal", color: additionalFilter.date ? "#111827" : "inherit", width: "100%", minWidth: "90px", maxWidth: "150px", textAlign: "center", padding: "2px 4px", fontSize: "10px", height: "22px", borderRadius: "3px"}} />
                  </div>
                </td>
                <td>
                  <div className="d-flex flex-column align-items-center">
                    <span style={{cursor: "pointer", userSelect: "none"}} onClick={() => handleHeaderSort("MachineFullName")}>Automat{arrow("MachineFullName")}</span>
                    <input type="text" className="form-control form-control-sm" onChange={({ target: { value } }) => setAdditionalFilter((prev) => ({...prev, machine: value}))} style={{ maxHeight: "20px", maxWidth: "150px" }}/>
                    </div>
                </td>
                <td>
                  <div className="d-flex flex-column align-items-center">
                    <span  style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("PA")}>{TRL_Pack.wi.Sales}{arrow("PA")}</span>
                    <input type="text" value={additionalFilter.pa || ""} onChange={({target:{value}}) => setAdditionalFilter(prev => ({...prev, pa: value}))} style={{backgroundColor: additionalFilter.pa ? "#d1d5db" : "#f8f9fa", border: additionalFilter.pa ? "2px solid #634b4b" : "1px solid #ccc", boxShadow: additionalFilter.pa ? "0 0 0 2px rgba(75,85,99,.15)" : "none", fontWeight: additionalFilter.pa ? "600" : "normal", color: additionalFilter.pa ? "#111827" : "inherit", width: "100%", minWidth: "90px", maxWidth: "150px", textAlign: "center", padding: "2px 4px", fontSize: "10px", height: "22px", borderRadius: "3px"}} />
                  </div>
                </td>
                <td>
                  <div className="d-flex flex-column align-items-center">
                    <span style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("KP")}>Rozliczenie monet{arrow("KP")}</span>
                    <input type="text" value={additionalFilter.kp || ""} onChange={({target:{value}}) => setAdditionalFilter(prev => ({...prev, kp: value}))} style={{backgroundColor: additionalFilter.kp ? "#d1d5db" : "#f8f9fa", border: additionalFilter.kp ? "2px solid #634b4b" : "1px solid #ccc", boxShadow: additionalFilter.kp ? "0 0 0 2px rgba(75,85,99,.15)" : "none", fontWeight: additionalFilter.kp ? "600" : "normal", color: additionalFilter.kp ? "#111827" : "inherit", width: "100%", minWidth: "90px", maxWidth: "150px", textAlign: "center", padding: "2px 4px", fontSize: "10px", height: "22px", borderRadius: "3px"}} />
                  </div>
                </td>
                <td>
                  <div className="d-flex flex-column align-items-center">
                    <span  style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("INm")}> Stan automatu{arrow("INm")}</span>
                    <input type="text" value={additionalFilter.inm || ""} onChange={({target:{value}}) => setAdditionalFilter(prev => ({...prev, inm: value}))} style={{backgroundColor: additionalFilter.inm ? "#d1d5db" : "#f8f9fa", border: additionalFilter.inm ? "2px solid #634b4b" : "1px solid #ccc", boxShadow: additionalFilter.inm ? "0 0 0 2px rgba(75,85,99,.15)" : "none", fontWeight: additionalFilter.inm ? "600" : "normal", color: additionalFilter.inm ? "#111827" : "inherit", width: "100%", minWidth: "90px", maxWidth: "150px", textAlign: "center", padding: "2px 4px", fontSize: "10px", height: "22px", borderRadius: "3px"}} />
                  </div>
                </td>
                <td>
                  <div className="d-flex flex-column align-items-center">
                    <span style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("DO")}>Doładowanie{arrow("DO")}</span>
                    <input type="text" value={additionalFilter.do || ""} onChange={({target:{value}}) => setAdditionalFilter(prev => ({...prev, do: value}))} style={{backgroundColor: additionalFilter.do ? "#d1d5db" : "#f8f9fa", border: additionalFilter.do ? "2px solid #634b4b" : "1px solid #ccc", boxShadow: additionalFilter.do ? "0 0 0 2px rgba(75,85,99,.15)" : "none", fontWeight: additionalFilter.do ? "600" : "normal", color: additionalFilter.do ? "#111827" : "inherit", width: "100%", minWidth: "90px", maxWidth: "150px", textAlign: "center", padding: "2px 4px", fontSize: "10px", height: "22px", borderRadius: "3px"}} />
                  </div>
                </td>
                <td>
                  <div className="d-flex flex-column align-items-center">
                    <span style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("KO")}>Korekta stanu{arrow("KO")}</span>
                    <input type="text" value={additionalFilter.ko || ""} onChange={({target:{value}}) => setAdditionalFilter(prev => ({...prev, ko: value}))} style={{backgroundColor: additionalFilter.ko ? "#d1d5db" : "#f8f9fa", border: additionalFilter.ko ? "2px solid #634b4b" : "1px solid #ccc", boxShadow: additionalFilter.ko ? "0 0 0 2px rgba(75,85,99,.15)" : "none", fontWeight: additionalFilter.ko ? "600" : "normal", color: additionalFilter.ko ? "#111827" : "inherit", width: "100%", minWidth: "90px", maxWidth: "150px", textAlign: "center", padding: "2px 4px", fontSize: "10px", height: "22px", borderRadius: "3px"}} />
                  </div>
                </td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              {filtered.map((entry, idx) => (
                    <tr className="text-center" key={idx}>
                      <td className="px-1 py-0">
                        <div className="d-flex flex-column justify-content-center align-items-center text-center">
                          <div className="btn text-wrap btn-sm btn-outline-primary">
                            {entry.WI}
                          </div>
                        </div>
                      </td>
                      <td className="px-1 py-0">
                        <div className="d-flex flex-column justify-content-center align-items-center text-center">
                          {entry.CreatedBy}
                        </div>
                      </td>
                      <td className="px-1 py-0">
                        <div className="d-flex flex-column justify-content-center align-items-center text-center">
                          {entry.VisitCreated}
                        </div>
                      </td>
                      <td className="px-1 py-0">
                        <div className="d-flex flex-column justify-content-center align-items-center text-center">{entry.MachineFullName}</div>
                      </td>
                      <td className="px-1 py-0">
                        <div className="d-flex flex-column justify-content-center align-items-center text-center">
                          {entry.SalesWarehouseOperationId !== null && (<Link to={`/pa/${entry.SalesWarehouseOperationId}`}className="btn text-nowrap btn-sm btn-outline-secondary">{entry.PA}</Link>)}
                        </div>
                      </td>
                      <td className="px-1 py-0">
                        <div className="d-flex flex-column justify-content-center align-items-center text-center">
                          {entry.MachineCoinInventoryId !== null  && (<button className="btn text-nowrap btn-sm btn-outline-success">{entry.KP}</button>)}
                          {entry.MachineCoinInventoryId === null && entry.IsTelemetry === 0 && (<button className="btn text-nowrap btn-sm btn-outline-success" onClick={() => addKP(entry.VisitId)}>Dodaj KP</button>)}
                        </div>
                      </td>
                      <td className="px-1 py-0">
                        <div className="d-flex flex-column justify-content-center align-items-center text-center">
                          {entry.MachineInventoryId !== null && (<Link to={`/inm/${entry.MachineInventoryId}`} className="btn text-nowrap btn-sm btn-outline-danger">{entry.INm}</Link>)}
                        </div>
                      </td>
                      <td className="px-1 py-0">
                        <div className="d-flex flex-column justify-content-center align-items-center text-center">
                          {entry.LoadMachineInventoryId !== null && (<Link to={`/do/${entry.LoadMachineInventoryId}`} className="btn text-nowrap btn-sm btn-outline-info">{entry.DO}</Link>)}
                        </div>
                      </td>
                      <td className="px-1 py-0">
                        <div className="d-flex flex-column justify-content-center align-items-center text-center">
                          {entry.CorrectionId !== null && (<Link to={`/ko/${entry.CorrectionId}`} className="btn text-nowrap btn-sm btn-outline-secondary mt-1">{entry.KO}</Link>)}
                        </div>
                      </td>
                      <td className="px-1 py-0">
                        <div className="d-flex flex-column justify-content-center align-items-center text-center">
                          <ReportButton reportId={51} body={{ visitId: entry.VisitId }} placement = "left" btnColor="danger" isPrimary/>
                        </div>
                      </td>
                    </tr>
                  ))
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default WIS;